import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { logout } from "@/redux/slices/authSlice";

export const ProtectedRoute = ({ children }) => {
	const { user, token } = useSelector((state) => state.auth);
	const location = useLocation();
	const dispatch = useDispatch();

	useEffect(() => {
		if (user && token) {
			const decodedJwt = jwtDecode(token);

			if (decodedJwt.exp !== null || decodedJwt.exp !== undefined) {
				if (decodedJwt.exp * 1000 < Date.now()) {
					dispatch(logout());
					window.location.href = "/login";
				}
			}
		}
	}, [dispatch, location, token, user]);

	if (user == null || token == null) {
		return <Navigate to="/login" />;
	}
	return children;
};
